import {
    CLEAR_ANTICOCCIDAL_LIST,
    SET_ANTICOCCIDAL_FILTER_DATA,
    SET_ANTICOCCIDAL_LIST,
    ANTICOCCIDAL_CREATE_DIALOG_CLOSE,
    ANTICOCCIDAL_CREATE_DIALOG_OPEN,
    ANTICOCCIDAL_CREATE_ERROR,
    ANTICOCCIDAL_CREATE_ERROR_CLEAR,
    ANTICOCCIDAL_CREATE_PENDING,
    ANTICOCCIDAL_EDIT_DIALOG_CLOSE,
    ANTICOCCIDAL_EDIT_DIALOG_OPEN,
    ANTICOCCIDAL_EDIT_ERROR,
    ANTICOCCIDAL_EDIT_ERROR_CLEAR,
    ANTICOCCIDAL_EDIT_PENDING,
    ANTICOCCIDAL_FILTER_DIALOG_CLOSE,
    ANTICOCCIDAL_FILTER_DIALOG_OPEN,
    ANTICOCCIDAL_LIST_ERROR,
    ANTICOCCIDAL_LIST_ERROR_CLEAR,
    ANTICOCCIDAL_LIST_PENDING,
} from "./constants"


const initialState = {
    //-----------------------------|| LIST ||---------------------------------------------------------------
    anticoccidalList: null,
    anticoccidalListCount: 0,
    isAnticoccidalListPending: false,
    anticoccidalListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isAnticoccidalFilterDialogOpen: false,
    anticoccidalFilterData: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isAnticoccidalCreateDialogOpen: false,
    isAnticoccidalCreatePending: false,
    anticoccidalCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isAnticoccidalEditDialogOpen: false,
    isAnticoccidalEditPending: false,
    anticoccidalEditErrorMessage: null,
}

const anticoccidals = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case ANTICOCCIDAL_LIST_PENDING: {
            return {
                ...state,
                isAnticoccidalListPending: true,
                anticoccidalListErrorMessage: null,
            }
        }

        case SET_ANTICOCCIDAL_LIST: {
            const { anticoccidalList } = action.payload || {};
            return {
                ...state,
                anticoccidalList: anticoccidalList['value'],
                anticoccidalListCount: anticoccidalList['@odata.count'],
                isAnticoccidalListPending: false,
                anticoccidalListErrorMessage: null,
            }
        }

        case ANTICOCCIDAL_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                anticoccidalListErrorMessage: errorMessage,
                isAnticoccidalListPending: false,
                anticoccidalList: null,
                anticoccidalListCount: 0,
            }
        }

        case ANTICOCCIDAL_LIST_ERROR_CLEAR: {
            return {
                ...state,
                anticoccidalListErrorMessage: null,
                isAnticoccidalListPending: false,
            }
        }
        case CLEAR_ANTICOCCIDAL_LIST: {
            return {
                ...state,
                anticoccidalList: null,
                anticoccidalListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case ANTICOCCIDAL_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isAnticoccidalFilterDialogOpen: true,
            }
        }
        case ANTICOCCIDAL_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isAnticoccidalFilterDialogOpen: false,
            }
        }

        case SET_ANTICOCCIDAL_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                anticoccidalFilterData: filter,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case ANTICOCCIDAL_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isAnticoccidalCreateDialogOpen: true,
            }
        }
        case ANTICOCCIDAL_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isAnticoccidalCreateDialogOpen: false,
            }
        }

        case ANTICOCCIDAL_CREATE_PENDING: {
            return {
                ...state,
                isAnticoccidalCreatePending: true,
                anticoccidalCreateErrorMessage: null,
            }
        }

        case ANTICOCCIDAL_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                anticoccidalCreateErrorMessage: errorMessage,
                isAnticoccidalCreatePending: false,
            }
        }

        case ANTICOCCIDAL_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                anticoccidalCreateErrorMessage: null,
                isAnticoccidalCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case ANTICOCCIDAL_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isAnticoccidalEditDialogOpen: true,
            }
        }
        case ANTICOCCIDAL_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isAnticoccidalEditDialogOpen: false,
            }
        }

        case ANTICOCCIDAL_EDIT_PENDING: {
            return {
                ...state,
                isAnticoccidalEditPending: true,
                anticoccidalEditErrorMessage: null,
            }
        }

        case ANTICOCCIDAL_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                anticoccidalEditErrorMessage: errorMessage,
                isAnticoccidalEditPending: false,
            }
        }

        case ANTICOCCIDAL_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                anticoccidalEditErrorMessage: null,
                isAnticoccidalEditPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default anticoccidals;